<template lang="pug">
.gestion-de-recursos
  i.ap-en-construccion
  .asu-title
    span En construcción
  //- .layout.row
    //- .flex.xs12.asu-title Recursos disponibles
    //- TwoColumnDataPanel(:obj="recursosDisponibles")
    //- .flex.xs12.asu-title.md2 Recursos necesarios
    //- .asu-subtitle Recursos físicos
    //- TwoColumnDataPanel(:obj="recursosNecesarios")
</template>

<script>
export default {
  data: () => ({
    recursosDisponibles: {
      'Recursos Humanos': '-',
      'Recursos Físicos': '-',
      'Recursos Técnicos': '-'
    },
    recursosNecesarios: {
      'Chapas fibrocemento': '-',
      'Puntales de madera 3x3': '-',
      'Terciadas multilaminadas': '-',
      'Sanitarios químicos instalados': '-'
    }
  })
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-info-scoped'

.gestion-de-recursos
  text-align: center
  .asu-title
    justify-content: center
    font-weight: bold
    color: $color_0
    margin: 0 0 $f10px 0
  .md-2
    margin-top: $f30px
  .asu-subtitle
    font-size: $f16px
    color: $color_0
    margin: $f10px 0 $f10px 0
  & >>>
    .mapper
      .flex.key, .flex.value
        font-size: $f17px
  .ap-en-construccion
    font-size: $f110px
    color: $color_0
</style>
